import React from 'react';
import CTAButton from '../../shared/CTAButton';
import { useFadeUp } from '../../shared/useFadeUp';
import { useCountUp } from '../../shared/useCountUp';
import { ceoPhoto } from '../../../assets/v2';
import './aboutUs.css';

const CREDS = [
  { text: 'Licensed PE (Civil) · CA, TX, NV', muted: false },
  { text: 'M.S. Civil Engineering, UCLA', muted: false },
  { text: '7 yrs structural inspection', muted: false },
  { text: 'Meta (ML Eng) · Microsoft (SWE)', muted: true },
];

const scrollToDownload = () =>
  document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });

const AboutUs: React.FC = () => {
  const founder = useFadeUp<HTMLDivElement>();
  const story = useFadeUp<HTMLDivElement>();
  const states = useCountUp(17);
  const years = useCountUp(7);

  return (
    <section className="v2-about" id="about">
      <div className="v2-about__container">
        <div
          ref={founder.ref}
          className={`v2-about__founder fade-up ${founder.isVisible ? 'is-visible' : ''}`}
        >
          <img className="v2-about__photo" src={ceoPhoto} alt="Morph founder" />
          <div className="v2-about__id">
            <div className="v2-about__name">Steven Tsai</div>
            <div className="v2-about__role">
              Founder &amp; CEO
              <br />
              Morph
            </div>
          </div>
          <ul className="v2-about__creds">
            {CREDS.map((c) => (
              <li
                key={c.text}
                className={c.muted ? 'v2-about__cred--muted' : ''}
              >
                {c.text}
              </li>
            ))}
          </ul>
        </div>

        <div
          ref={story.ref}
          className={`v2-about__story fade-up ${story.isVisible ? 'is-visible' : ''}`}
        >
          <h2 className="ui-h2">Built by someone who&rsquo;s been there.</h2>
          <p className="ui-body">
            Morph started with frustration in the field.
          </p>
          <p className="ui-body">
            I spent seven years in structural engineering, conducting inspections
            across the U.S. I loved the work on site, but report writing often
            took longer than the inspection itself. Long nights, repetitive
            documentation, and software that didn&apos;t understand how
            inspectors actually work.
          </p>
          <p className="ui-body">It didn&apos;t feel right.</p>
          <p className="ui-body">
            Morph was built to give that time back — not to replace judgment,
            but to remove the busywork so inspectors can focus on the job that
            truly matters.
          </p>
          <p className="v2-about__signature">
            Built by someone who&rsquo;s been there. Built for those still in
            the field.
          </p>

          <div className="v2-about__stats">
            <div>
              <div className="v2-about__stat-value">
                <span ref={states.ref}>{states.value}</span>
              </div>
              <div className="ui-eyebrow">States with active inspectors</div>
            </div>
            <div>
              <div className="v2-about__stat-value">
                <span ref={years.ref}>{years.value}</span>
              </div>
              <div className="ui-eyebrow">Years in the field</div>
            </div>
            <div>
              <div className="v2-about__stat-value">InterNACHI</div>
              <div className="ui-eyebrow">Vendor partner</div>
            </div>
          </div>

          <CTAButton variant="blue" size="lg" onClick={scrollToDownload}>
            Start your free trial
          </CTAButton>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
